import { Star } from "lucide-react";

export function StarRating({
  value,
  size = 14,
  className = "",
}: {
  value: number;
  size?: number;
  className?: string;
}) {
  const full = Math.floor(value);
  const half = value - full >= 0.25 && value - full < 0.75;
  const total = 5;
  return (
    // role="img" makes the aria-label a permitted attribute for assistive tech and AI agents.
    <span
      role="img"
      className={`inline-flex items-center gap-0.5 ${className}`}
      aria-label={`Rated ${value.toFixed(1)} out of 5`}
    >
      {Array.from({ length: total }).map((_, i) => {
        const filled = i < full;
        const isHalf = !filled && i === full && half;
        return (
          <Star
            key={i}
            size={size}
            strokeWidth={1.5}
            className={
              filled
                ? "fill-amber-400 text-amber-400"
                : isHalf
                  ? "fill-amber-400/50 text-amber-400"
                  : "text-amber-300"
            }
          />
        );
      })}
    </span>
  );
}
